export enum AuctionLogActionEnum {
    UserConnected = 1,
    UserDisconnected = 2,
    PlacedBid = 3,
    AuctionPaused = 4,
    AuctionStarted = 5,
    AuctionItemBidAcceptance = 6,
    AuctionItemWon = 7,
    AuctionItemWithdrawn = 8,
    AuctionItemRebid = 9,
    MessagePosted = 10,
    MessageRemoved = 11,
    TypedBid = 12,
    AuctionItemStatusUpdate = 13,
    AuctionStatusUpdate = 14
}